@if (routeData(); as result) {
    <ms-my-bets-view [inputData]="result.model" [isInitalLoadReadyFromRouteComponent]="result.isRouteDataLoaded" />
}
